import { render, staticRenderFns } from "./IpSelect.vue?vue&type=template&id=64f52580"
import script from "./IpSelect.vue?vue&type=script&lang=js"
export * from "./IpSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports